<template>
  <div>
    <div class="mt-1">
      <strong class="mr-50">Status integração proposta:</strong>
      <font-awesome-icon
        :icon="faRobot"
        :class="[{'sucesso-integracao': sucessoIntegracaoProposta()}, {'erro-integracao': erroIntegracaoProposta()}, {'pendente-integracao': pendenteIntegracaoProposta()}]"
        style="font-size:1.3rem !important;"
      />
      <span :class="[{'sucesso-integracao': sucessoIntegracaoProposta()}, {'erro-integracao': erroIntegracaoProposta()}, {'pendente-integracao': pendenteIntegracaoProposta()}]">
        {{ erroIntegracaoProposta() ? 'Erro' : pendenteIntegracaoProposta() ? 'Pendente' : 'Sucesso' }}</span>
    </div>
    <div class="mt-50">
      <b-textarea
        v-model="textoIntegracao"
        :disabled="true"
        no-resize
        style="height: 25vh;"
      />
    </div>

    <div v-if="dataExecucaoContrato">
      <span style="font-size: 0.7rem;font-weight: 500;">Data: {{ dataContrato }}</span>
    </div>

    <div
      v-if="emps.some(som => som.id === 0)"
      style="text-align: center;text-decoration: underline;margin-top: 0.25em;"
      :class="[{'disable-click': alteradoGClick}]"
    >
      <span
        style="cursor: pointer;"
        @click="alterarStatusContrato()"
      >Alterar o status para Sucesso manualmente!</span>
    </div>

    <div class="mt-1">
      <b-btn
        variant="success"
        size="sm"
        class="w-100"
        @click="integrarManualmente"
      >
        Integrar com a G-Click
      </b-btn>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faRobot,
} from '@fortawesome/free-solid-svg-icons'
import { getUserData } from '@/auth/utils'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'

export default {
  name: 'GClickIntegrationTab',
  components: {
    FontAwesomeIcon,
    // InfoChecklist: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/checklist-proposta/shared/components/InfoChecklist.vue'),
  },
  props: {
    empresas: {
      type: Array,
      default: () => [],
    },
    propostaId: {
      type: Number,
      default: 0,
    },
    dataExecucao: {
      type: String,
      default: null,
    },
    dataExecucaoContrato: {
      type: String,
      default: null,
    },
    alteradoStatusGClickManualmente: {
      type: Boolean,
      default: false,
    },
    contratante: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      colunas: [
        {
          key: 'Serviço', label: 'Serviço', thStyle: 'width: 500px; padding:5px', tdClass: 'row-table-faturamento',
        },
        {
          key: 'Faturamento', label: 'Faturamento', thStyle: 'width: 135px; padding: 5px', tdClass: 'row-table-faturamento',
        },
        {
          key: 'Ação', label: 'Ação', thStyle: 'width: 50px; padding: 5px', tdClass: 'column-acoes',
        },
      ],
      faRobot,
      emps: this.empresas,
      data: this.dataExecucao,
      dataContrato: this.dataExecucaoContrato,
      alteradoGClick: this.alteradoStatusGClickManualmente,
      contratanteProposta: this.contratante,
      servicoSelected: null,
      servicosStatus: [],
      textoIntegracao: '',
      botaoDesabilitado: true,
    }
  },
  computed: {
    ...mapGetters('proposta', ['proposta', 'getStatusProposta', 'getTodosServicos']),
  },
  watch: {
    empresas(value, oldValue) {
      if (value !== oldValue) {
        this.emps = value
      }
    },
    dataExecucao(value, oldValue) {
      if (value !== oldValue) {
        this.data = value
      }
    },
    dataExecucaoContrato(value, oldValue) {
      if (value !== oldValue) {
        this.dataContrato = value
      }
    },
    alteradoStatusGClickManualmente(value, oldValue) {
      if (value !== oldValue) {
        this.alteradoGClick = value
      }
    },
    contratante(value, oldValue) {
      if (value !== oldValue) {
        this.contratanteProposta = value
      }
    },
    TextoIntegracao(value, oldValue) {
      if (value !== oldValue) {
        this.textoIntegracao = value
      }
    },
    botaoDesabilitado(value, oldValue) {
      if (value !== oldValue) {
        this.botaoDesabilitado = value
      }
    },
  },
  created() {
    this.emps = this.empresas
    this.data = this.dataExecucao
    this.dataContrato = this.dataExecucaoContrato
  },
  updated() {
    if (this.proposta.statusGClick !== 5 && ((this.proposta.tipoProposta === 'semchecklist' && this.proposta.etiquetas.some(s => s.descricao === 'Aprovada')))) {
      this.show()
    }
  },
  mounted() {
    this.atualizarTextoIntegracao()
  },
  methods: {
    show() {
      this.servicosStatus = this.getTodosServicos
      this.atualizarTextoIntegracao()
    },
    updateStatus(value) {
      const servicoUpdate = {
        id: value.id,
        statusFaturamento: value.statusFaturamento,
        isPacoteServico: value.isServicoPacote,
      }
      api.atualizarStatusFaturamentoServico(servicoUpdate.id, servicoUpdate)
        .then(payload => {
          const index = this.servicosStatus.findIndex(i => i.id === payload.data.id)
          this.servicosStatus[index].usuCadastro = payload.data.usuAlteracaoStatusFaturamento
          this.servicosStatus[index].dataCadastro = payload.data.dataAlteracaoStatusFaturamento
        })
        .catch(err => {
          this.$handleError(err)
        })
    },
    getTextoEmpresa(value, msgContrato) {
      switch (value.statusGClick) {
        case 4:
          return `${value.cadastroFederal ?? value.inscricao} - Empresa disponível no banco de dados G-Click.\n`
        case 2:
          return `${value.cadastroFederal ?? value.inscricao} - Criado novo cadastro na G-Click!\n`
        case 3:
          return `${value.cadastroFederal ?? value.inscricao} - Erro: ${value.mensagemErroGClick}\n`
        case 1:
          return !msgContrato ? 'Aguardando CNPJ da empresa para iniciar a integração!' : msgContrato
        default:
          return `Status desconhecido (${value.statusGClick}) para a empresa ${value.cadastroFederal ?? value.inscricao}.\n`
      }
    },
    getTextoEmpresas() {
      let texto = ''
      if (this.emps && this.emps.length > 0) {
        this.emps.forEach(each => {
          if (each.empresaResumida.id > 0) {
            texto += this.getTextoEmpresa(each.empresaResumida, each.mensagemContrato)
          } else {
            texto += `${each.mensagemContrato}\n`
          }
        })
      } else if (this.contratanteProposta) {
        texto += this.getTextoEmpresa(this.contratanteProposta)
      }
      return texto
    },
    integrarManualmente() {
      if (getUserData().permissaoGClick) {
        this.$confirmar('', 'Deseja realizar a integração com a G-Click agora?', 'question', 'danger')
          .then(result => {
            if (result.value) {
              this.$isLoading(true)
              api.integrarEmpresasManualmenteGClick(this.proposta.id)
                .then(() => {
                  this.atualizarTextoIntegracao()
                })
                .catch(async err => {
                  // Busca os cadastros e monta o texto detalhado
                  this.atualizarTextoIntegracao()
                  this.$erro(err.response?.data?.message || err.message)
                })
                .finally(() => {
                  this.$isLoading(false)
                })
            }
          })
      } else {
        this.$erro('Você não tem permissão para realizar essa ação!')
      }
    },
    async atualizarEstadoBotaoIntegracao() {
      try {
        const response = await api.buscaCadastrosGClickByPropostaId(this.proposta.id)
        const registros = response.data || []
        return registros.some(r => r.statusIntegracao === 1 || r.statusIntegracao === 3)
      } catch (e) {
        return true
      }
    },
    sucessoIntegracao() {
      return this.proposta.statusGClick === 4 || this.proposta.statusGClick === 2
    },
    erroIntegracao() {
      return this.proposta.statusGClick === 3
    },
    pendenteIntegracao() {
      return this.proposta.statusGClick === 1
    },
    sucessoIntegracaoProposta() {
      return this.proposta.statusGClick === 4 || this.proposta.statusGClick === 2
    },
    erroIntegracaoProposta() {
      return this.proposta.statusGClick === 3
    },
    pendenteIntegracaoProposta() {
      return this.proposta.statusGClick === 1
    },
    alterarStatusContrato() {
      this.$confirmarHtml('', 'Ao alterar o status da proposta para Sucesso não será possível reverter a ação!<br>Tem certeza que deseja continuar?', 'question', 'danger')
        .then(result => {
          if (result.value) {
            api.alterarStatusSucessoManualmente(this.propostaId)
              .then(() => {
                this.$router.go()
              })
          }
        })
    },
    async atualizarTextoIntegracao() {
      try {
        const response = await api.buscaCadastrosGClickByPropostaId(this.proposta.id)
        const registros = response.data || []
        let texto = ''
        if (registros.length === 0) {
          texto = 'Nenhum registro foi encontrado para esta proposta.'
        } else {
          // Funções auxiliares para buscar nomes
          const getNomeEmpresa = empresaId => {
            const empresa = (this.proposta.empresasVinculadas || []).find(e => e.empresaResumida?.id === empresaId)
            return empresa ? (empresa.empresaResumida.nome || empresa.empresaResumida.razaoSocial || `EmpresaId: ${empresaId}`) : `EmpresaId: ${empresaId}`
          }
          const getNomeServico = servicoId => {
            const servicoObj = (this.proposta.servicos || []).find(s => s.servico?.id === servicoId)
            if (servicoObj && servicoObj.servico) {
              return servicoObj.servico.nome || `ServiçoId: ${servicoId}`
            }
            const adicional = (this.proposta.servicosAdicionais || []).find(s => s.id === servicoId || s.servico?.id === servicoId)
            if (adicional) {
              return adicional.nome || adicional.servico?.nome || `ServiçoId: ${servicoId}`
            }
            return `ServiçoId: ${servicoId}`
          }

          const sucesso = registros.filter(r => r.statusIntegracao === 4 || r.statusIntegracao === 2)
          const erro = registros.filter(r => r.statusIntegracao === 3)
          const pendente = registros.filter(r => r.statusIntegracao === 1)

          if (sucesso.length > 0) {
            texto += 'Integrados com sucesso:\n'
            sucesso.forEach(r => {
              if (r.tipoRegistro === 1) {
                texto += `- ${getNomeEmpresa(r.empresaId)}\n`
              } else if (r.tipoRegistro === 2) {
                texto += `- ${getNomeServico(r.servicoId)}\n`
              }
            })
          }
          if (erro.length > 0) {
            texto += '\nFalha na integração:\n'
            erro.forEach(r => {
              if (r.tipoRegistro === 1) {
                texto += `- ${getNomeEmpresa(r.empresaId)}: ${r.mensagemErro ?? 'Erro desconhecido'}\n`
              } else if (r.tipoRegistro === 2) {
                texto += `- ${getNomeServico(r.servicoId)}: ${r.mensagemErro ?? 'Erro desconhecido'}\n`
              }
            })
          }
          if (pendente.length > 0) {
            texto += '\nPendentes de integração:\n'
            pendente.forEach(r => {
              if (r.tipoRegistro === 1) {
                texto += `- ${getNomeEmpresa(r.empresaId)}\n`
              } else if (r.tipoRegistro === 2) {
                texto += `- ${getNomeServico(r.servicoId)}\n`
              }
            })
          }
          if (sucesso.length === 0 && erro.length === 0 && pendente.length === 0) {
            texto = 'Nenhum registro integrado, pendente ou com erro encontrado.'
          }
        }
        this.textoIntegracao = texto
      } catch (e) {
        this.textoIntegracao = 'Erro ao buscar registros de integração.'
      }
    },
  },
}
</script>

<style lang="scss">

.container-table {
min-height: 70vh;
overflow-y: auto;
margin-bottom: 1rem;

}

.sucesso-integracao {
  color: #28c76f;
}

.erro-integracao {
  color: #ea5455;
}

.pendente-integracao {
  color: #ffc107;
}

.disable-click {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.list-servico {
  border: 1px solid;
}

.btn-info button {
  height: 27px;
}

.row-table-faturamento{
  padding: 5px !important;
}

.column-acoes {
  padding: 5px 5px 5px 15px !important;
}
</style>
